import { VxSwalError } from '@voxie/frontend-components';
import { HTTP_INTERNAL_SERVER_ERROR } from '~/support/HttpStatuses';

export function catchRequestError(error) {
    console.error(error);
    if (!error?.response?.status || error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
        return 'Something went wrong.';
    } else {
        const data = error.response?.data;
        return data?.message || data?.errors?.[0]?.detail || 'Something went wrong.';
    }
}

export function throwSwalRequestError(error) {
    throw new VxSwalError(catchRequestError(error));
}
